import PropTypes from "prop-types";

function ErrorEntry({
  size = 25,
  fillColor = "fill-black",
  iconColor = "stroke-white"
}) {
  return (
    <svg
      fill="none"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1.5"
        width="13"
        height="13"
        fill="#FF4B00"
        className={`stroke-black ${fillColor}`}
      />
      <path
        strokeWidth="2"
        className={iconColor}
        d="M5.25879 5L11.5176 11.4674"
      />
      <path
        strokeWidth="2"
        className={iconColor}
        d="M11.2588 5L4.99994 11.4674"
      />
    </svg>
  );
}

ErrorEntry.propTypes = {
  size: PropTypes.number,
  fillColor: PropTypes.string,
  iconColor: PropTypes.string
};

export default ErrorEntry;
